<template>
    <div class="avatar" :style="avatarStyle">
      <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
      <template v-else>
      <slot v-if="$slots.default" />
      <span v-else>{{ firstChar }}</span>
    </template>   
   </div>
  </template>
  
  <script>
  export default {
    name: "AvatarComponent",
    props: {
      borderRadius: {
        type: String,
        default: "0%", // mặc định bo tròn
      },
      text: {
        type: String,
        required: true,
      },
      imageUrl: {
        type: String,
        default: "",
      },
      backgroundColor: {
        type: String,
        default: "", // để rỗng, sẽ sinh màu từ text nếu không có
      },
      textColor: {
        type: String,
        default: "#ffffff",
      },
      size: {
        type: Number,
        default: 40,
      },
    },
    computed: {
      firstChar() {
        return this.text ? this.text.charAt(0).toUpperCase() : "?";
      },
      resolvedBackgroundColor() {
        if (this.backgroundColor) return this.backgroundColor;
  
        // Google-style hash color generator
        const colors = [
          "#F4B400", // yellow
          "#0F9D58", // green
          "#DB4437", // red
          "#4285F4", // blue
          "#AB47BC", // purple
          "#00ACC1", // cyan
        ];
        let hash = 0;
        for (let i = 0; i < this.text.length; i++) {
          hash = this.text.charCodeAt(i) + ((hash << 5) - hash);
        }
        const index = Math.abs(hash) % colors.length;
        return colors[index];
      },
      avatarStyle() {
        if (this.imageUrl) return {
          width: `${this.size}px`,
          height: `${this.size}px`,
        };
        
        return {
          backgroundColor: this.resolvedBackgroundColor,
          color: this.textColor,
          width: `${this.size}px`,
          height: `${this.size}px`,
          fontSize: `${this.size * 0.5}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: this.borderRadius,
          fontWeight: "bold",
          textTransform: "uppercase",
        };
      },
    },
  };
  </script>
  
  <style scoped>
  .avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
  </style>
  